module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-waiting-room-e1a64156533f0d8a540e84158ce95b81.png";